module.exports = __webpack_public_path__ + "static/marketing-7dff42b4716813ae08e5783c606f2c01.jpg";